
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/declaration-of-use-services",
      function () {
        return require("private-next-pages/declaration-of-use-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/declaration-of-use-services"])
      });
    }
  